import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 p-4">
      <div className="card max-w-md w-full text-center">
        <h1 className="text-4xl font-bold text-indigo-500 mb-4">404</h1>
        <p className="text-xl mb-6">Page Not Found</p>
        <p className="text-slate-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary inline-block">
          Return Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
